var _ellipse, _rect, _rect2, _g, _rect3, _rect4, _g2, _rect5, _g3, _rect6, _g4, _rect7, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCombination(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1305_79598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9385,
    cy: 28,
    rx: 27.9111,
    ry: 28,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1305_79598)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.967773,
    y: -3,
    width: 39.873,
    height: 40,
    fill: "#FFD362",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1305_79598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 37,
    width: 41,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9043,
    y: 77,
    width: 40,
    height: 39.873,
    transform: "rotate(-90 38.9043 77)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1305_79598)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9003 37.5079C75.5852 23.5559 58.6223 13.9999 39.0482 13.9999C11.2654 13.9999 -42.4121 57 -42.4121 57C-42.4121 57 11.2654 100 39.0482 100C58.6266 100 75.5927 90.4397 83.9058 76.4827C82.5899 76.7584 81.2262 76.9033 79.8287 76.9033C68.869 76.9033 59.9845 67.9905 59.9845 56.9959C59.9845 46.0013 68.869 37.0885 79.8287 37.0885C81.2242 37.0885 82.5861 37.233 83.9003 37.5079Z",
    fill: "#E36328"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9053,
    y: -3,
    width: 39.873,
    height: 40,
    fill: "#54C7E4",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1305_79598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: -3,
    width: 41,
    height: 40
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9043,
    y: -3,
    width: 39.873,
    height: 40,
    fill: "#D37DC6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1305_79598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9678 -3H36.8408C48.991 -3 58.8408 6.84974 58.8408 19V37H18.9678V-3Z",
    fill: "#D37DC6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1305_79598",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -3,
    width: 40,
    height: 40
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.96875,
    y: -3,
    width: 39.873,
    height: 40,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1305_79598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.9043,
    cy: 17,
    rx: 19.9365,
    ry: 20,
    fill: "#FFB053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1153 37H18.9665C18.9012 33.7465 16.3433 31.13 13.1973 31.13H5.56041C3.74096 31.13 2.87981 29.9136 2.87981 29.1325C2.87981 28.3514 3.74096 27.135 5.56041 27.135H12.4386C15.7056 27.135 18.9678 24.7719 18.9678 21.1375C18.9678 17.5031 15.7056 15.14 12.4386 15.14H5.56041C3.74096 15.14 2.87981 13.9236 2.87981 13.1425C2.87981 12.3614 3.74096 11.145 5.56041 11.145H12.4386C15.7056 11.145 18.9678 8.78195 18.9678 5.1475C18.9678 1.51306 15.7056 -0.849995 12.4386 -0.849995H5.56041C3.74096 -0.849995 2.87981 -2.06643 2.87981 -2.8475C2.87981 -3.62857 3.74097 -4.845 5.56041 -4.845H12.4386C15.7056 -4.845 18.9678 -7.20806 18.9678 -10.8425C18.9678 -10.8953 18.9671 -10.9478 18.9657 -11H15.1082C15.1156 -10.946 15.1192 -10.8933 15.1192 -10.8425C15.1192 -10.0614 14.258 -8.845 12.4386 -8.845H5.56041C2.29344 -8.845 -0.96875 -6.48194 -0.96875 -2.8475C-0.96875 0.786949 2.29345 3.15001 5.56041 3.15001H12.4386C14.258 3.15001 15.1192 4.36643 15.1192 5.1475C15.1192 5.92858 14.258 7.145 12.4386 7.145H5.56041C2.29345 7.145 -0.96875 9.50806 -0.96875 13.1425C-0.96875 16.7769 2.29345 19.14 5.56041 19.14H12.4386C14.258 19.14 15.1192 20.3564 15.1192 21.1375C15.1192 21.9186 14.258 23.135 12.4386 23.135H5.56041C2.29345 23.135 -0.96875 25.4981 -0.96875 29.1325C-0.96875 32.7669 2.29345 35.13 5.56041 35.13H13.1973C14.2175 35.13 15.0521 35.9562 15.1153 37Z",
    fill: "#72C1E1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1305_79598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -19,
    y: 37,
    width: 40,
    height: 40
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -18.9102,
    y: 37,
    width: 39.873,
    height: 40,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1305_79598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02635,
    cy: 57,
    rx: 19.9365,
    ry: 20,
    fill: "#FF757A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1305_79598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 37,
    width: 41,
    height: 40
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9619,
    y: 37,
    width: 39.873,
    height: 40,
    fill: "#E8E8E8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1305_79598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.704 63.6902C14.5006 76.3646 -4.85675 77.5666 -15.5319 66.375C-26.207 55.1834 -24.1574 35.8361 -10.954 23.1617C2.24937 10.4874 47.0878 6.26423 47.0878 6.26423C47.0878 6.26423 40.9074 51.0158 27.704 63.6902Z",
    fill: "#1A99CC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombination);
export default __webpack_public_path__ + "static/media/combination.27839846aa7da25700b35c8218230337.svg";
export { ForwardRef as ReactComponent };